import { render } from "./AlianzaComercial.vue?vue&type=template&id=31be9abb&scoped=true"
const script = {}

import "./AlianzaComercial.vue?vue&type=style&index=0&id=31be9abb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31be9abb"]])

export default __exports__